import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import Course from '../../../interfaces/Course';
import Unit from '../../../interfaces/Unit';
import Quiz from '../../../interfaces/Quiz';


@Component({
  template: require('./course-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class CoursePage extends vue {

  resetUnitPopupShow = false;
  resetUnitBlock = 0;
  resetedUnitBlock = false;

  // Preloader
  get loading() {
    return this.loadingUser && this.loadingLesson && this.courseLoaded;
  }

  get loadingUser() {
    return this.$store.state.loadingUser;
  }

  get loadingLesson() {
    return this.userProgress.length > -1;
  }

  get courseLoaded(){
    if(this.courseData[this.courseData.length - 1]){
      if (this.lessonsData.find((lesson => {
        return lesson.unitId === this.courseData[this.courseData.length - 1].units[0].id;
      }))){
        return true;
      }
    }
    else{
      return false;
    }
  }
  // Expiration
  get expired() {
    if (new Date(this.$store.state.user.expiration.replace(/ /g,"T")) > new Date()){
      return false;
    }
    else{
      if (this.userProgress.length > 0 && this.lessonsData.length > 0){
        if (this.userProgress[this.userProgress.length - 1].type == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].type){
          return this.userProgress[this.userProgress.length - 1].id != this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id;
        }
      }
      return true;
    }
  }

  //  Data
  get courseData() {
    return this.$store.state.course;
  }

  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userProgress() {
    return this.$store.state.progress.filter((lesson) => {
      return !lesson.hasOwnProperty('reset');
    });
  }

  lessonResultPercentage(lesson) {
    return this.userProgress[this.lessonProgressIndex(lesson)].resultPercentage;
  }

  lessonPass(lesson) {
    return this.lessonProgressIndex(lesson) > -1 && !this.userProgress[this.lessonProgressIndex(lesson)].hasOwnProperty('reset');
  }

  lessonProgressIndex(lesson) {
    return this.userProgress.indexOf(this.userProgress.find((progress) => {
      return lesson.id === progress.id && lesson.type === progress.type && !progress.hasOwnProperty('reset');
    }));
  }

  lessonOpen(lesson){
    if (this.userProgress.length == 0){
      if (lesson.id === this.lessonsData.find((lesson) => {return lesson.order === '000'}).id && lesson.type ===  this.lessonsData.find((lesson) => {return lesson.order === '000'}).type){
        return true;
      }
      return false;
    }
    else{
      if (this.userProgress.indexOf(this.userProgress.find((progress) => {
        return lesson.id === progress.id && lesson.type === progress.type && !progress.hasOwnProperty('reset');
      })) >  -1){
        return true;
      }
      else{
        const prevlesson = this.lessonsData[this.lessonsData.indexOf(this.lessonsData.find((lesson) => {return lesson.id === this.userProgress[this.userProgress.length - 1].id && lesson.type === this.userProgress[this.userProgress.length - 1].type})) + 1];
        if(prevlesson && lesson.id === prevlesson.id && lesson.type === prevlesson.type){
          if (this.userProgress[this.userProgress.length - 1].type === 'App\\Models\\Quiz' && !this.userProgress[this.userProgress.length - 1].hasOwnProperty('result')){
            return false;
          }
          return true;
        }
        if (lesson.id === this.lessonsData.find((lesson) => {return lesson.order === '000'}).id && lesson.type ===  this.lessonsData.find((lesson) => {return lesson.order === '000'}).type){
          return true;
        }
        return false;
      }
    }
  }
  resetUnitPopup(block) {
    this.resetUnitBlock = block;
    this.resetUnitPopupShow = true;
    this.resetedUnitBlock = this.unitResetBefore(block);
  }

  resetUnit(blocks) {
    let progress = [...this.userProgress];

    blocks.units.forEach((unit) => {

      progress.forEach((p) => {

        if (p.unitId == unit.id) {

          p.reset = true;
          p.pass = false;
        }
      });
    });
    // Promise.all([
    //   this.$store.dispatch('saveProgress', progress)
    // ]).finally(() => {
    //   window.location.href = "/";
    // })
    this.$store.dispatch('saveProgress', progress)
    .then(() => {
      setTimeout(() => {
        location.reload();
      }, 600);
    });
    this.resetUnitPopupShow = false;
  }

  isLesson(type) {
    return (type === 'App\\Models\\Lesson') ? true : false;
  }

  isQuiz(type) {
    return (type === 'App\\Models\\Quiz') ? true : false;
  }

  unitScore(blocks) {
    let units = [];
    let total = 0;

    blocks.units.forEach((unit) => {
      let blocksUnits = this.userProgress.filter((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
      });
      // here was a mistake, system take only the first exam in the unit
      blocksUnits.forEach((blocksUnit, i) => {
        units.push(blocksUnit);
      });
    });

    units.forEach((unit, i) => {
      if (units[i]) {
        total += units[i].resultPercentage;
      }
    });

    let avg = total / units.length;
    return avg;

  }
  unitResetBefore(blocks) {
    let unitLessonsReset = [];
    let unitLessons = [];

    blocks.units.forEach((unit) => {
      let blocksUnitLessonsReset = this.userProgress.find((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz' && lesson.hasOwnProperty('reset');
      });
      if (blocksUnitLessonsReset) {
        unitLessonsReset.push(blocksUnitLessonsReset);
      }

      let blocksUnitLessons = this.lessonsData.find((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz';
      });
      if (blocksUnitLessons) {
        unitLessons.push(blocksUnitLessons);
      }
    });
    if (unitLessons.length == unitLessonsReset.length) {
      return true;
    }
    return false;
  }
  unitPass(blocks) {
    let unitLessonsPass = [];
    let unitLessons = [];

    blocks.units.forEach((unit) => {
      let blocksuUnitLessonsPass = this.userProgress.filter((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
      });
      if (blocksuUnitLessonsPass) {
        unitLessonsPass.push(blocksuUnitLessonsPass);
      }

      let blocksuUnitLessons = this.lessonsData.filter((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz';
      });
      if (blocksuUnitLessons) {
        unitLessons.push(blocksuUnitLessons);
      }
    });
    // console.log(unitLessons[unitLessons.length - 1].length == unitLessonsPass[unitLessons.length - 1].length);
    if (unitLessons[unitLessons.length - 1].length == unitLessonsPass[unitLessons.length - 1].length) {
      return true;
    }
    return false;
  }
}